
import { type FC, memo } from 'react';

import { translations } from './SelectLanguage';

import './LetsStartPopUp.css';


interface LetsStartPopUpProps {
    onBackClick: ()=> void;
    onStartClick: ()=> void;
}

export const LetsStartPopUp: FC<LetsStartPopUpProps> = memo(({ onBackClick, onStartClick }) => {
    const handleBackClick = () => {
        onBackClick();
    }
    const handleStartClick = () => {
        onStartClick();
    }
    return (
        <div className="popUp">
            <div className="letsStartTitle">{translations.chooseColor}</div>
            <div className="instruction">
                    <div
                        className="color"
                        style={{background: "green"}}
                    >
                        <span>{translations.green}</span>
                    </div>
                    <div>{translations.greenExplanation}</div>

                    <div
                        className="color"
                        style={{background: "yellow"}}
                    >
                        <span>{translations.yellow}</span>
                    </div>
                    <div>{translations.yellowExplanation}</div> 


                    <div
                        className="color"
                        style={{background: "red"}}
                    >
                        <span>{translations.red}</span>
                    </div>
                    <div>{translations.redExplanation}</div>
            </div>
            <div className="navigationButtonContainer">
                <button
                    onClick={handleBackClick}
                    className="navigationButton"
                    style={{background: "grey"}}
                >
                    <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24">
                        <path d="M0 0h24v24H0z" fill="none"/>
                        <path d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z"/>
                    </svg>
                     {translations.navigationBack}
                </button>
                <button
                    onClick={handleStartClick}
                    className="navigationButton"
                    style={{background: "#1ddb24"}}
                >
                    <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24">
                        <path d="M0 0h24v24H0z" fill="none"/>
                        <path d="M8 5v14l11-7z"/>
                    </svg>
                    {translations.navigationStart}
                </button>
            </div>

        </div>
  );
});
